<template>
    <section id="contato">
        <notifications group="foo" position="top right"/>
        <div class="container p-container">

            <h2 class="titulo">{{ $t('contato.titulo') }}</h2>

            <div class="row">
                <div class="info col-md-5">
                    <ul>
                        <li v-for="(item, index) in infoList" :key="index">
                            <a :href="item.link" target="_black">
                                <img :src="item.icon" alt="">
                            </a>
                            <!-- <p>{{ item.label }}:</p> -->
                            <a :href="item.link" :class="item.class" target="_blank">{{ item.text }}</a>
                        </li>
                    </ul>
                </div>
                <div class="form col-md-7">
                    <b-form @submit.prevent="submit">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-input v-model="form.nome"
                                    type="text"
                                    :placeholder="$t('contato.input.nome')">
                                </b-form-input>
                                <b-form-input v-model="form.email"
                                    type="email"
                                    :placeholder="$t('contato.input.email')">
                                </b-form-input>
                                <b-form-input
                                    v-model="form.telefone"
                                    type="text"
                                    :placeholder="$t('contato.input.telefone')"
                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                </b-form-input>
                                <b-form-input v-model="form.subject"
                                    type="text"
                                    :placeholder="$t('contato.input.assunto')">
                                </b-form-input>
                            </div>
                            <div class="col-md-6">
                                <b-form-textarea id="textarea1"
                                    v-model="form.message"
                                    :placeholder="$t('contato.input.mensagem')"
                                    :rows="4"
                                    :max-rows="6">
                                </b-form-textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="offset-md-6 col-md-6">
                                <a v-on:click="submit" class="btn btn-success gaec-contato-mensagem">{{ $t('contato.input.enviar') }}</a>
                            </div>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import services from '@/http'

import IcEmail from '@/assets/img/icons/mail.svg'
import IcWhatsapp from '@/assets/img/icons/social/whatsapp.svg'
import IcInstagram from '@/assets/img/icons/social/instagram.svg'
import IcTwitter from '@/assets/img/icons/social/twitter.svg'
import IcFacebook from '@/assets/img/icons/social/facebook.svg'
import IcYoutube from '@/assets/img/icons/social/youtube.svg'

export default {
    name: 'Contato',
    data () {
        return {
            form: {
                nome: '',
                email: '',
                telefone: '',
                subject: '',
                message: '',
                template: 'contatoSite'
            },
            infoList: [
                {
                    class: 'gaec-contato-whatsapp',
                    icon: IcWhatsapp,
                    label: this.$t('contato.info.telefone'),
                    text: '+55 21 98383-8581 ',
                    link: 'https://api.whatsapp.com/send?phone=5521964278792'
                },
                {
                    class: 'gaec-contato-whatsapp',
                    icon: IcWhatsapp,
                    label: this.$t('contato.info.telefone'),
                    text: '+55 21 96635-1912',
                    link: 'https://api.whatsapp.com/send?phone=5521964278792'
                },
                {
                    class: 'gaec-contato-email',
                    icon: IcEmail,
                    label: this.$t('contato.info.email'),
                    text: 'contato@sambamaniacos.com.br',
                    link: '#contato'
                },
                {
                    class: 'gaec-contato-facebook',
                    icon: IcFacebook,
                    label: this.$t('contato.info.facebook'),
                    text: 'sambamaniacos.oficial',
                    link: 'https://www.facebook.com/sambamaniacos.oficial'
                },
                {
                    class: 'gaec-contato-instagram',
                    icon: IcInstagram,
                    label: this.$t('contato.info.instagram'),
                    text: '@sambamaniacos',
                    link: 'https://www.instagram.com/sambamaniacos/'
                },
                {
                    class: 'gaec-contato-twitter',
                    icon: IcTwitter,
                    label: this.$t('contato.info.twitter'),
                    text: '@sambamaniacos',
                    link: 'https://twitter.com/sambamaniacos'
                },
                {
                    class: 'gaec-contato-youtube',
                    icon: IcYoutube,
                    label: this.$t('contato.info.youtube'),
                    text: 'Vídeos do Sambamaníacos',
                    link: 'https://www.youtube.com/results?search_query=sambamaniacos'
                }
            ]
        }
    },
    methods: {
        notification: function (mensagem) {
            this.$notify({
                group: 'foo',
                type: 'warn',
                title: this.$t('contato.notification.obrigatorio'),
                text: mensagem
            })
        },
        validaForm: function (form) {
            if (!form.nome) {
                this.notification(this.$t('contato.notification.nome'))
            } else if (!form.email) {
                this.notification(this.$t('contato.notification.email'))
            } else if (!form.telefone) {
                this.notification(this.$t('contato.notification.telefone'))
            } else if (!form.subject) {
                this.notification(this.$t('contato.notification.assunto'))
            } else if (!form.message) {
                this.notification(this.$t('contato.notification.mensagem'))
            } else {
                return true
            }

            return false
        },
        submit: function (e) {
            console.log(event)
            if (this.validaForm(this.form)) {
                this.form.subject = 'Contato site - ' + this.form.subject
                this.sendmail(JSON.stringify(this.form))
            }
        },
        sendmail: function (payload) {
            services.contato.sendmail(payload)
                .then(res => {
                    this.form = {
                        nome: '',
                        email: '',
                        telefone: '',
                        assunto: '',
                        mensagem: ''
                    }
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'success',
                        title: this.$t('contato.notification.eba'),
                        text: this.$t('contato.notification.enviado')
                    })
                })
                .catch(err => {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'error',
                        title: 'Ops!',
                        text: this.$t('contato.notification.falha')
                    })
                    console.error(err)
                })
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../assets/sass/_mixin"
    #contato
        padding-bottom: 80px
        margin-top: 80px
        @include device(mobile)
            &
                margin-top: 50px
                padding-bottom: 50px
        .titulo
            text-align: center
            margin-bottom: 50px
        .info
            @include device(mobile)
                &
                    padding-bottom: 40px

                    ul
                        li
                            font-size: 0.9em
            ul
                margin: 0
                padding: 0
                list-style-type: none
                li
                    display: inline-flex
                    align-items: flex-end
                    width: 100%
                    margin-bottom: 15px
                    img
                        width: 20px
                        margin-right: 10px
                    a
                        &:hover
                            color: green!important

                        &,
                        &:visited,
                        &:link,
                        &:active
                            color: black
                            text-decoration: none
                    p
                        margin-bottom: 0
                        margin-right: 6px

        .form
            input
                margin-bottom: 15px
                border-radius: 2px
                &:last-of-type
                    margin-bottom: 0px

                    @include device(mobile)
                        &
                            margin-bottom: 15px

                &::-webkit-input-placeholder
                    color: #b3b1b1
                &:-moz-placeholder
                    color: #b3b1b1
                &::-moz-placeholder
                    color: #b3b1b1
                &:-ms-input-placeholder
                    color: #b3b1b1

            textarea
                margin-bottom: 15px
                height: 100%!important

                &::-webkit-input-placeholder
                    color: #b3b1b1
                &:-moz-placeholder
                    color: #b3b1b1
                &::-moz-placeholder
                    color: #b3b1b1
                &:-ms-input-placeholder
                    color: #b3b1b1
            .btn-success
                margin-top: 15px
                width: 100%
                color: white
                cursor: pointer

                &:hover,
                &:focus
                    color: white
</style>
